var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"form-group flex"},[(!_vm.withoutLabel)?_c('label',{attrs:{"for":_vm.name}},[_vm._v(_vm._s(_vm.label))]):_vm._e(),_c('rating',{staticClass:"ml-auto",attrs:{"customGetColor":_vm.customGetColor},model:{value:(_vm.value),callback:function ($$v) {_vm.value=$$v},expression:"value"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }